export default __webpack_public_path__ + "static/media/ic_user_active.98a871e8.svg";